import React, { useEffect, useState } from 'react';
import {  Button, Form, Input, Message} from 'semantic-ui-react'

import { ConnectWS } from '../../../ConnectWS'
import { useToasts } from 'react-toast-notifications';
import { Link } from "react-router-dom";



function RegistrationNew(props) {
    const { addToast } = useToasts();


    const [registrationStatus, setregistrationStatus] = useState(null);
    const [loading, setloading] = useState(false);

    const [form, setForm] = useState({
        name: '',
        surname: '',
        password: '',
        passwordConfirmed: '',
        email: '',
        regulamin: false,
        rodo: false
    });



    useEffect(() => {
        if (Number(process.env.REACT_APP_API_DEBUG) === 1) {
            console.log("View: Registration")
        }

       
        return () => { }; // use effect cleanup to set flag false, if unmounted
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const submitLogin = e => {
        e.preventDefault();
        setloading(true)
        setregistrationStatus(null)
        let name = form.name
        let surname = form.surname
        let password = form.password
        let passwordConfirmed = form.passwordConfirmed
        let email = form.email.toLowerCase()
        let regulamin = form.regulamin
   


        if (regulamin === false) {

            setregistrationStatus({ value: "Proszę zaznaczyć zapoznanie się z regulaminem oraz z polityką prywatności", error: true, success: false })
            setloading(false)
            return
        }
       
        if (password !== passwordConfirmed) {
            setregistrationStatus({ value: "Wpisane hasła różnią się od siebie", error: true, success: false })
            setloading(false)
            return
        }


        ConnectWS("login/registerAccount", null, { name: name, surname: surname, password: password, email: email, generatorTL: 1 }, function (response, logout) {

            if (logout === 1) {

            } else if (response && response.status && Number(response.status) === 200) {
                setregistrationStatus({ value: response.data.message, error: false, success: true })
             
                addToast(response.data.message, { appearance: 'success' });

                // setAuth(true, response.data.token, null, null, null, null);
            } else {
                console.log(response.error)
                setregistrationStatus({ value: response, error: true, success: false })
                //addToast(response, { appearance: 'error' });
                //console.log(response);
            }

            setloading(false)
            // closeOpenModalR()

        });


    }


   
    return (
        <>

            <Form onSubmit={submitLogin} size='mini'>
              
                    <Form.Field
                        control={Input}
                        required
                        maxLength="25"
                        label='Imię'
                        placeholder='Imię'
                        value={form.name}
                        onChange={(e, data) => setForm({ ...form, name: data.value })}
                    />
                    <Form.Field
                        control={Input}
                        required
                        label='Nazwisko'
                        maxLength="25"
                        placeholder='Nazwisko'
                        value={form.surname}
                        onChange={(e, data) => setForm({ ...form, surname: data.value })}
                    />
             

                <Form.Group widths='equal'>

                    <Form.Field
                        control={Input}
                        required
                        label='E-mail'
                        type="email"
                        placeholder='E-mail'
                        value={form.email}
                        onChange={(e, data) => setForm({ ...form, email: data.value })}
                    />
                </Form.Group>
                <Form.Group widths='equal'>
                    <Form.Field
                        control={Input}
                        required
                        label='Hasło (min. 6 znaków)'
                        placeholder='Hasło'
                        type='password'
                        maxLength="25"
                        minLength="6"
                        value={form.password}
                        onChange={(e, data) => setForm({ ...form, password: data.value })}
                    />

                    <Form.Field
                        control={Input}
                        required
                        label='Powtórz Hasło'
                        placeholder='Powtórz Hasło'
                        type='password'
                        maxLength="25"
                        minLength="6"
                        value={form.passwordConfirmed}
                        onChange={(e, data) => setForm({ ...form, passwordConfirmed: data.value })}
                    />
                </Form.Group>

                <Form.Group inline>
                    <Form.Checkbox onChange={(e, data) => setForm({ ...form, regulamin: data.checked })} inline required /><div style={{marginTop:-7}}>Rejestrując się akceptujesz<Link to="regulamin" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5 }}>regulamin</Link> oraz<Link to="polityka-prywatnosci" target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5 }}>politykę prywatności</Link></div>
                </Form.Group>

     
                <Button disabled={form.regulamin === false || loading} fluid color="google plus" loading={loading ? true : false} >ZAKŁADAM DARMOWE KONTO</Button>
            </Form>

            {registrationStatus ? <Message
                error={registrationStatus.error ? true : false}
                success={registrationStatus.success ? true : false}
                content={registrationStatus.value}
            /> : ''}

            <div style={{marginTop:20,fontSize:13,cursor:"pointer"}} onClick={()=>props.setshowRegistration(false)}>
            Posiadasz już konto? Kliknij <span className='tllink'>tutaj</span> aby się zalogować.
            </div>



        </>
    )
}

export default RegistrationNew;